var $2eXIH$detectorjsdetector = require("@detector-js/detector");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "Detector", () => $6a31c933d71b1d5d$re_export$Detector);

"use strict";


//# sourceMappingURL=detector.js.map
